import React from "react";
import { render } from "react-dom";
import { BrowserRouter as Router } from "react-router-dom"; 
import ReturnsPortal from "./components/ReturnsPortal"; 
import configureStore from "./redux/configureStore";
import { Provider as ReduxProvider } from "react-redux"; 
import 'bootstrap/dist/js/bootstrap';
const store = configureStore();

render( 
    <ReduxProvider store={store}> 
        <Router> 
            <ReturnsPortal /> 
        </Router> 
    </ReduxProvider>, 
document.getElementById("returnsPortal")
);



// WEBPACK FOOTER //
// ./src/index.js